import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';

export const userIdentityConflictSortOptions: OptionsDictionary = {
};
